import { useState } from "react";
import { Loader2, CheckCircle2, Mail } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("idle"); // idle | busy | done | error
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const em = email.trim().toLowerCase();
    if (!em || !em.includes("@")) { setStatus("error"); setMsg("Inserisci un indirizzo email valido."); return; }
    setStatus("busy"); setMsg("");
    try {
      const r = await fetch(`${API}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: em, name: name.trim() }),
      });
      if (!r.ok) throw new Error();
      setStatus("done");
    } catch {
      setStatus("error"); setMsg("Iscrizione non riuscita. Riprova più tardi.");
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-4 py-12 text-white" data-testid="subscribe-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="mb-2 inline-flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-yellow-400 font-black text-black">T</span>
            <span className="font-heading text-xl font-black tracking-tight">TORRI<span className="ml-1 text-xs font-medium text-yellow-400">BEYOND ORDINARY SOLAR</span></span>
          </div>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 shadow-2xl backdrop-blur">
          {status === "done" ? (
            <div className="text-center" data-testid="subscribe-success">
              <CheckCircle2 className="mx-auto mb-3 h-12 w-12 text-emerald-400" />
              <h1 className="font-heading text-2xl font-black">Iscrizione confermata!</h1>
              <p className="mt-2 text-sm text-white/60">Grazie, ti terremo aggiornato sulle novità del mondo Torri.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="text-center">
                <h1 className="font-heading text-2xl font-black">Iscriviti alla newsletter</h1>
                <p className="mt-1 text-sm text-white/60">Novità, prodotti ed eventi Torri, direttamente nella tua casella.</p>
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-white/50">Nome (facoltativo)</label>
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Il tuo nome o azienda"
                       className="w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2.5 text-sm outline-none focus:border-yellow-400/60" data-testid="subscribe-name" />
              </div>
              <div>
                <label className="mb-1 block text-xs font-medium text-white/50">Email *</label>
                <div className="relative">
                  <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-white/40" />
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@esempio.it" required
                         className="w-full rounded-lg border border-white/10 bg-black/40 py-2.5 pl-9 pr-3 text-sm outline-none focus:border-yellow-400/60" data-testid="subscribe-email" />
                </div>
              </div>
              {status === "error" && <p className="text-xs text-red-400" data-testid="subscribe-error">{msg}</p>}
              <button type="submit" disabled={status === "busy"}
                      className="flex w-full items-center justify-center gap-2 rounded-lg bg-yellow-400 py-2.5 text-sm font-bold text-black transition hover:bg-yellow-300 disabled:opacity-60" data-testid="subscribe-submit">
                {status === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
                Iscrivimi
              </button>
              <p className="text-center text-[11px] text-white/40">Potrai disiscriverti in qualsiasi momento dal link presente in ogni email.</p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
